function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as r } from "react/jsx-runtime";
import { useIsInverseVariant as a } from "../../theme-variant-context.js";
import { vars as c } from "../../skins/skin-contract.css-mistica.js";
const l = (_param)=>{
    var { color: s , size: o = 24  } = _param, t = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const e = a(), i = s !== null && s !== void 0 ? s : e ? c.colors.inverse : c.colors.neutralHigh;
    return /* @__PURE__ */ r("svg", _object_spread_props(_object_spread({
        width: o,
        height: o,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: /* @__PURE__ */ r("path", {
            fill: i,
            d: "M20.337 19.147c0 .394-.31.713-.694.713a.704.704 0 01-.694-.713c0-.394.31-.713.694-.713.383 0 .694.319.694.713zm-1.121-1.797a.359.359 0 00.24-.444l-.591-2.14c-.205-.786-.885-1.335-1.654-1.335h-3.207L12.368 7.04a2.694 2.694 0 001.37-2.36c0-1.476-1.17-2.679-2.606-2.679-1.437 0-2.606 1.203-2.606 2.68a2.69 2.69 0 001.178 2.235 1.794 1.794 0 00-.827 1.514v3.928c0 .983.778 1.788 1.739 1.788h5.074c.089.416.138.836.138 1.248 0 3.25-2.57 5.894-5.732 5.894-3.162 0-5.732-2.643-5.732-5.894 0-2.259 1.285-4.349 3.277-5.323a.36.36 0 00.165-.475.345.345 0 00-.463-.17C5.111 10.519 3.67 12.86 3.67 15.394 3.67 19.037 6.552 22 10.096 22s6.425-2.963 6.425-6.607c0-.416-.04-.832-.12-1.248h.81c.462 0 .858.324.982.813l.592 2.145a.353.353 0 00.431.247zM9.22 4.68c0-1.084.858-1.967 1.912-1.967 1.054 0 1.912.883 1.912 1.966 0 1.084-.858 1.967-1.917 1.967-1.054-.005-1.907-.883-1.907-1.967zm1.391 8.751c-.573 0-1.04-.48-1.04-1.07V8.433c0-.59.467-1.07 1.04-1.07h1.121l1.556 6.073h-1.983v-.005h-.694z"
        })
    }));
}, v = l;
export { v as default };
